export const STEPS_COUNT = 2;
